<template>
  <div>
    <NavBreadCrumb class="mb-12 lg:mb-16" :title="blok.title" />
    <section class="mx-auto flex max-w-screen-xl px-6 md:px-8">
      <!-- Desktop Sidebar -->
      <section
        class="rte hidden h-full min-w-[288px] max-w-[288px] overflow-y-auto bg-grey-50 pl-4 lg:block"
      >
        <SbHelpCentreSidebarContent :search-input="true" />
      </section>
      <section class="rte w-full lg:ml-16 lg:px-0">
        <div v-editable="blok">
          <div class="tag">
            {{ categoryTitle }}
          </div>
          <h1>{{ blok.title }}</h1>
          <p class="text-sm text-grey-500">Last Updated: {{ formattedDate }}</p>
          <SbUtilRichTextRender :article-content="blok.articleContent" />
          <SbUtilWasThisHelpful />
        </div>
      </section>
    </section>
  </div>
</template>

<script setup lang="ts">
import type { ISbRichtext } from "storyblok-js-client";

const props = defineProps<{
  blok: {
    title: string;
    tag: string;
    articleContent: ISbRichtext;
  };
  publishedAt: string;
  parentId: number;
}>();

// Category ID's
// Accounts and Billing: 77152
// Internet: 74672
// Mobile: 74673
// Phone: 74674

const categoryTitle =
  props.parentId === 77152
    ? "Accounts and Billing"
    : props.parentId === 74672
      ? "Internet"
      : props.parentId === 74673
        ? "Mobile"
        : props.parentId === 74674
          ? "Phone"
          : "";

const formattedDate = new Date(props.publishedAt).toLocaleDateString("en-au", {
  weekday: "long",
  year: "numeric",
  month: "short",
  day: "numeric",
});
</script>
